<table
  mat-table
  multiTemplateDataRows
  class="mat-elevation-z1 top-margin-15"
  id="failed-jobs-table"
  [dataSource]="dataSource"
>
  <ng-container matColumnDef="name">
    <th
      *matHeaderCellDef
      mat-header-cell
    >
      Művelet Neve
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="tags">
    <th
      *matHeaderCellDef
      mat-header-cell
    >
      Címkék
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.tags.join(", ") }}
    </td>
  </ng-container>

  <ng-container matColumnDef="queue">
    <th
      *matHeaderCellDef
      mat-header-cell
    >
      Queue
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.queue }}
    </td>
  </ng-container>

  <ng-container matColumnDef="failed_at">
    <th
      *matHeaderCellDef
      mat-header-cell
    >
      Hiba Ideje
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.failed_at * 1000 | date: "yyyy.MM.dd HH:mm" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="retry">
    <th
      *matHeaderCellDef
      mat-header-cell
    >
      Hiba Ideje
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      <button
        payee-button
        width="shorter"
        height="short"
        (click)="retryJob(element); $event.stopPropagation()"
      >
        Újraküldés
      </button>
    </td>
  </ng-container>

  <!-- Expanded Content Column -->
  <ng-container matColumnDef="expandedDetail">
    <td
      *matCellDef="let element"
      mat-cell
      [attr.colspan]="displayedColumns.length"
    >
      @if (expandedElement === element) {
        <div class="detail-column">
          @if (element.retried_by) {
            <div class="flex column">
              <h1>Retries</h1>
              @for (retried_by of element.retried_by; track retried_by.id) {
                <div>
                  <div class="flex vcenter retry-item">
                    <div>
                      {{ retried_by.retried_at * 1000 | date: "yyyy.MM.dd." }}
                    </div>
                    <div class>{{ retried_by.status }}</div>
                  </div>
                </div>
              }
            </div>
          }
          <div class="flex column">
            <h1>Hibaüzenet</h1>
            <span>{{ element.exception }}</span>
          </div>
        </div>
      }
    </td>
  </ng-container>

  <tr
    *matHeaderRowDef="displayedColumns"
    mat-header-row
  ></tr>
  <tr
    *matRowDef="let element; columns: displayedColumns"
    mat-row
    class="element-row"
    (click)="toggleExpandedElement(element)"
  ></tr>
  <tr
    *matRowDef="let row; columns: ['expandedDetail']"
    mat-row
    class="detail-row"
    [class.expanded-row]="expandedElement === row"
  ></tr>
</table>

<mat-paginator
  showFirstLastButtons
  class="mat-elevation-z1"
  [disabled]="loading"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="[5, 10, 25, 100]"
  [length]="length"
  (page)="pageChange($event)"
></mat-paginator>
